// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.


const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:761c118c-d715-4060-a7a0-1eff3fb26eb8",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_mxxe1Mz1f",
    "aws_user_pools_web_client_id": "1jalddaq0aog168m802c9qme6c",
    "oauth": {}
};


export default awsmobile;
